import { createSlice } from "@reduxjs/toolkit";
import { updateCompany, updateCompanyLogo } from "../thunks/companyThunk";
import { ICompanyState } from "../types/company";

const initialState: ICompanyState = {
  company: null,
  loading: false,
  error: null,
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.company = action.payload as any;
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateCompanyLogo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompanyLogo.fulfilled, (state, action) => {
        state.loading = false;
        state.company = action.payload as any;
      })
      .addCase(updateCompanyLogo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading } = companySlice.actions;
export default companySlice.reducer; 